const REDIRECT_PARAM = "redirect";

export const loginPath = (redirect: string): string => {
  if (redirect === "/") {
    return "/login";
  }
  return `/login?${new URLSearchParams({ [REDIRECT_PARAM]: redirect })}`;
};

/**
 * Redirect path once the user has logged in.
 */
export const pathAfterLogin = (search: string): string => {
  const redirect = new URLSearchParams(search).get(REDIRECT_PARAM);
  if (!redirect) {
    return "/";
  }

  let url: URL;
  try {
    url = new URL(redirect, window.location.origin);
  } catch {
    return "/";
  }

  // Make sure we have a legit redirect path, same origin, valid url.
  if (url.origin !== window.location.origin || url.pathname.startsWith("//")) {
    return "/";
  }

  return url.pathname + url.search + url.hash;
};
